import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from '../../common/Popup';
import * as irActions from '../../../redux/actions/irSearch';
import loadingSpinnerImage from '../../../images/loadingSpinner.gif';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import DocketDetailsPurchaseForm from './DocketDetailsPurchaseForm';
import loadingBarImage from '../../../images/loadingBar.gif';


class AllPartsPrintPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      text: '',
    };
  }

  componentDidMount() {
    this.props.dispatch(irActions.loadFavoriteEmails());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.favoriteEmail.status !== this.props.favoriteEmail.status) {
      this.setState({ email: this.props.favoriteEmail.email });
    }

    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.downloadPdfCombined();
    }
  }

  buy = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      const { docket_numbers, case_uuid } = this.props.popup.data;
      const { email, text } = this.state;
      const params = {
        case_uuid,
        'docket_numbers[]': docket_numbers,
        email_address: email,
        email_message: text,
      };
      this.props.dispatch(irActions.buyAllParts(params))
        .then(() => this.downloadPdfCombined());
    } else {
      this.props.onClose();
    }
  }

  downloadPdfCombined = () => {
    const { docket_numbers, case_uuid } = this.props.popup.data;
    const { email, text } = this.state;

    const params = {
      case_uuid,
      'docket_numbers[]': docket_numbers,
      email_address: email,
      email_message: text,
    };

    this.props.dispatch(irActions.downloadPdfCombined(params))
      .then(this.props.reloadDetails);
  }

  // showing 10 instead of 0 as default, so it at least appears like it's loading something
  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  );

  render() {
    const purchaseFormOrLoading = (this.props.docketParts.status === 'loading')
      ? <div className="loading-bar"><img src={loadingBarImage} /></div>
      : <DocketDetailsPurchaseForm
          docketParts={this.props.docketParts}
          buy={this.buy} />;

    return (
      <Popup show={this.props.popup.show}
             clsName="docket-pdf-zip-popup"
             topBarTitle="Print Preview"
             onClose={this.props.onClose}>
        { purchaseFormOrLoading }
      </Popup>
    );
  }
}

AllPartsPrintPreview.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  favoriteEmail: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, docketParts, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(AllPartsPrintPreview);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/AllPartsPrintPreview.jsx
 **/